module.exports = __webpack_public_path__ + "static/img/jata.ed496e3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jata.jpeg
// module id = OtkC
// module chunks = 175